__webpack_require__.p = "/wp-content/themes/appverselabs/react-app/";